// test1857
(1857 && 0);
